<template>
  <div class="content-background" v-loading="isShowLoading">
    <div class="content-mode">
      <div class="header">
        <div class="left" @click="changeTap(AttachmentMediaTypeEnum.IMAGE.code)">
          <label class="label" :class="{'selected-label': mediaType === AttachmentMediaTypeEnum.IMAGE.code }">图文模式</label>
          <p class="icon" v-if="mediaType === AttachmentMediaTypeEnum.IMAGE.code"></p>
        </div>
        <div class="right" @click="changeTap(AttachmentMediaTypeEnum.VIDEO.code)">
          <label class="label" :class="{'selected-label': mediaType === AttachmentMediaTypeEnum.VIDEO.code }">视频模式</label>
          <p class="icon" v-if="mediaType === AttachmentMediaTypeEnum.VIDEO.code"></p>
        </div>
      </div>
      <div class="divider-container">
        <div class="content-divider"></div>
      </div>
    </div>
    <div class="add-content">
      <div class="content">
        <div class="content-title">
          <p class="content-label">标题</p>
          <el-input
            v-model="title"
            placeholder="请输入标题"
            type="text"
            class="content-title-input"
            maxlength="20" :show-word-limit="true"></el-input>
            <span class="limit">{{title? title.length: 0}}/20</span>
        </div>
        <div class="content-title">
          <p class="content-label">标题（英文）</p>
          <el-input
            v-model="titleEn"
            placeholder="请输入标题（英文）"
            type="text"
            class="content-title-input"
            maxlength="50" :show-word-limit="true"></el-input>
            <span class="limit">{{titleEn? titleEn.length: 0}}/50</span>
        </div>
        <div class="content-cover" v-if="mediaType === AttachmentMediaTypeEnum.VIDEO.code">
          <p class="content-label">封面</p>
          <div v-if="coverImage&&coverImage.src" class="content-cover-image">
            <img class="content-cover-button" :src="coverImage.src | ossImageProcess">
            <el-button type="text"
              @click="handleRemoveCover"
              icon="icon-remove-image"
              class="image-remove-icon"></el-button>
          </div>
          <el-button
            v-else
            type="text"
            @click="handleCoverChange"
            class="content-cover-button"
            icon="icon-add-cover"></el-button>
        </div>
        <div class="content-image">
          <p class="content-label">内容素材</p>
            <div class="content-image-list">
              <div v-for="(item, index) in displayImages" v-bind:key="item" class="content-image-item">
                <img class="content-cover-button" :src="item.src | ossImageProcess">
                <el-button type="text"
                  @click="handleRemoveContentImage(index)"
                  icon="icon-remove-image"
                  class="image-remove-icon"></el-button>
              </div>
              <el-button v-if="images.length < 9 && mediaType === AttachmentMediaTypeEnum.IMAGE.code"
                class="content-image-add"
                icon="icon-add-image"
                @click="handleContentImageChange"
              ></el-button>
              <el-upload
                class="content-image-item"
                :auto-upload="false"
                :show-file-list="false"
                v-if="mediaType === AttachmentMediaTypeEnum.VIDEO.code&&videoImages.length < 1"
                :on-change="handleVideoChange"
                accept="video/*">
                  <el-button
                    class="content-image-add"
                    icon="icon-add-image"
                  ></el-button>
              </el-upload>
            </div>
            <p class="content-label" style="margin-bottom: 0">正文</p>
            <div class="content-area">
              <el-input
                v-model="content"
                type="textarea"
                :rows="7"
                class="content-image-input"
                placeholder="请输入正文内容">
              </el-input>
            </div>
            <p class="content-label" style="margin-bottom: 0">正文（英文）</p>
            <div class="content-area">
              <el-input
                v-model="contentEn"
                type="textarea"
                :rows="7"
                class="content-image-input"
                placeholder="请输入正文内容（英文）">
              </el-input>
            </div>
        </div>
        <div class="content-publish">
          <div class="content-topic">
            <p class="content-label">话题</p>
            <el-button @click="addTagDialogVisible = true" type="primary"
                class="content-topic-button"
                size="medium">添加话题</el-button>
          </div>
          <div class="show-tags">
            <el-tag
              :key="tag.id"
              :title="tag.name"
              v-for="tag in checkedTags"
              closable
              @close="handleClose(tag)">
              # {{tag.name}}
            </el-tag>
          </div>
          <!-- <div class="content-link">
            <p class="content-label">链接</p>
            <el-button @click="openAddLinkDialog" type="primary"
                class="content-link-button"
                size="medium">添加链接</el-button>
          </div> -->
          <div class="show-links">
            <el-tag
              :key="index"
              v-for="(link, index) in checkedLinks"
              closable
              @close="handleRemoveCheckedLink(link, index)">
              <div class="link" @click="clickLink(link.url)">
                <i class="icon-link"></i>
                <span>{{link.text}}</span>
              </div>
            </el-tag>
          </div>
          <div class="content-topic-divider"></div>
          <div class="content-footer">
            <!-- <el-button class="preview">预览</el-button> -->
            <!-- <el-button class="save" @click="savePost(bannedTypeEnum.BANNED.value)">保存</el-button>-->
            <!-- <el-button class="schedule-publish">定时发布</el-button> -->
            <el-button class="publish" @click="savePost(bannedTypeEnum.BANNED.value)">保存</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="添加话题" :visible.sync="addTagDialogVisible" class="handle-dialog">
      <div class="search">
      <el-autocomplete
        v-model="searchTag"
        :fetch-suggestions="searchChange"
        placeholder="搜索话题"
        @select="handleSelect"
        suffix-icon="el-icon-search"
      >
        <template slot-scope="{ item }">
          <div class="tag-item">
            <span class="tag-name">{{ item.name }}</span>
          </div>
        </template>
      </el-autocomplete>
      </div>
      <div class="content">
        <div class="left">
          <el-menu
            class="el-menu-vertical-demo">
            <el-menu-item v-for="(item, index) in parentTagOptions" :key="index" :index="index" @click.native="handleOpen(item)">
              <span slot="title">{{item.label}}</span>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="right">
          <el-checkbox-group v-model="checkedTagIds">
            <el-checkbox v-for="tag in tags" :label="tag.id" :key="tag.id" :title="tag.name" @change="onCheckboxChange"># {{tag.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="footer">
        <div class="tags">
          <el-tag
            :key="tag.id"
            v-for="tag in checkedTags"
            :title="tag.name"
            closable
            @close="handleClose(tag)">
            # {{tag.name}}
          </el-tag>
        </div>
        <el-button @click="addTagDialogVisible = false" type="primary">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加链接" :visible.sync="addLinkDialogVisible" class="handle-dialog">
      <div class="links-content">
        <div class="domain-white-list">域名白名单： {{domainWhiteList.join("，")}}</div>
        <div class="links">
          <el-form ref="linksForm" :model="linksForm" label-width="100px" size="medium">
            <el-form-item>
              <div class="link" v-for="(link, index) in linksForm.links" :key="index">
                <div class="text">
                  <label>文本</label>
                  <el-form-item :prop="'links.' + index + '.text'" :rules="[
                    { type: 'string', required: true, message: '请输入文本', trigger: 'blur' },
                  ]">
                  <el-input v-model="link.text" :maxlength="512" placeholder="" size="small"></el-input>
                  </el-form-item>
                </div>
                <div class="text-en">
                  <label>文本（英文）</label>
                  <el-form-item :prop="'links.' + index + '.textEn'" :rules="[
                    { type: 'string', required: true, message: '请输入文本（英文）', trigger: 'blur' },
                  ]">
                  <el-input v-model="link.textEn" :maxlength="512" placeholder="" size="small"></el-input>
                  </el-form-item>
                </div>
                <div class="url">
                  <label>地址</label>
                  <el-form-item :prop="'links.' + index + '.url'" :rules="[
                    { type: 'string', required: true, message: '请输入地址', trigger: 'blur' },
                    { validator: validateURL, trigger: 'blur' }
                  ]">
                  <el-input v-model="link.url" :maxlength="512" placeholder="" size="small"></el-input>
                  </el-form-item>
                </div>
                <i class="el-icon-circle-plus-outline" @click="addLink" v-if="index===linksForm.links.length-1"></i>
                <i class="el-icon-remove-outline" @click="removeLink(link, index)"></i>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="footer">
        <el-button @click="confirmAddLinks('linksForm')" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import '@/styles/content.scss'
  import { createPost, updatePost, getPost } from '@/api/post/post';
  import { getTagsByType, fetchRelateItemList, fetchItemList } from '@/api/basic/tagtype'
  import { remote } from '@/api/admin/dict';
  import AttachmentMediaTypeEnum from '@/common/enums/AttachmentMediaTypeEnum';
  import * as util from '@/util/util';
  import tencentVodService from  '@/common/common-logic/tencentVod';
  import tencentCloud from '@/api/basic/tencent-cloud';
  import postTypeEnum from '@/common/enums/postTypeEnum';
  import bannedTypeEnum from '@/common/enums/bannedTypeEnum';
  import uploadService from '@/common/common-logic/upload-service';
  import _ from 'lodash';

  export default {
    data() {
      const validateURL = (rule, value, callback) => {
        if (!value.startsWith('https://') && !value.startsWith('http://')) {
          callback(new Error('地址必须以 https:// 或 http:// 开头'));
          return;
        }
        const isURL = util.isURL(value);
        if (!isURL) {
          callback(new Error('请输入正确格式的地址'));
        } else {
          if (this.domainWhiteList.length === 0) {
            callback(new Error('请先配置域名白名单'));
            return;
          }
          const url = util.parseURL(value);
          if (!this.domainWhiteList.includes('*') && !this.domainWhiteList.includes(url.hostName)) {
            callback(new Error('只能输入域名白名单的链接'));
          } else {
            callback();
          }
        }
      };
      return {
        timeout: null,
        parentTagOptions: [],
        tags: [],
        allTags: [],
        checkedTags: [],
        checkedTagIds: [],
        domainWhiteList: [],
        post: '',
        content: '',
        contentEn: '',
        title: '',
        titleEn: '',
        tag: [],
        id: '',
        url: '',
        coverImage: null,
        images: [],
        videoImages: [],
        mediaType: AttachmentMediaTypeEnum.IMAGE.code,
        video: null,
        isShowLoading: false,
        isEdit: false,
        AttachmentMediaTypeEnum,
        circleId: Number(this.$route.query.circleId),
        showMaterialSelector: false,
        bannedTypeEnum,
        addTagDialogVisible: false,
        searchTag: '',
        addLinkDialogVisible: false,
        linksForm: {
          links: [],
        },
        validateURL,
        checkedLinks: [],
      }
    },
    computed: {
      displayImages() {
        if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
          return this.images;
        } else if (this.mediaType === AttachmentMediaTypeEnum.VIDEO.code) {
          return this.videoImages;
        }
        return [];
      },
    },
    methods: {
      onCheckboxChange() {
        this.checkedTags = this.allTags.filter(item => {
          return this.checkedTagIds.includes(item.id);
        });
      },
      async handleOpen(val) {
        const response = await this.requestWrapper(fetchRelateItemList, {size: 9999}, val.value);
        if (!response || response.ok === false || response.code !== 0) {
          vm.$message({
            showClose: true,
            message: '未查询到话题',
            type: 'error'
          });
        }
        this.tags = response.data.records.map(item => {
          return {
            id: item.id,
            name: item.name,
            nameEn: item.nameEn,
          }
        });
        this.mergeTags(this.tags);
      },
      mergeTags (tags) {
        tags.forEach(item => {
          if (!this.allTags.find(tag => tag.id === item.id)) {
            this.allTags.push(item);
          }
        });
      },
      async getRelatedTagOptionse() {
        const response = await this.requestWrapper(getTagsByType, {type: 2});
        if (!response || response.ok === false || response.code !== 0) {
          vm.$message({
            showClose: true,
            message: '未查询到话题分类',
            type: 'error'
          });
        }
        if (Array.isArray(response.data)) {
          this.parentTagOptions = response.data.map(x => {
            return {
              value: x.id,
              label: x.name
            }
          })
        }
      },
      handleClose(tag) {
        this.checkedTags = this.checkedTags.filter(item => { return item.id != tag.id });
        this.checkedTagIds = this.checkedTagIds.filter(item => { return item != tag.id });
      },
      changeTap(mediaType) {
        this.mediaType = mediaType
        // this.checkedTags = [];
      },
      searchChange(queryString, cb) {
        this.requestWrapper(fetchItemList, {status:1, type: 3, size: 9999, keywords: this.searchTag }).then((response) => {
          const results = [];
          if (response.ok) {
            if (response.data && response.data.records) {
              response.data.records.forEach((record) => {
                results.push({
                  id: record.id,
                  name: record.name,
                });
              });
              // 调用 callback 返回建议列表的数据
              cb(results);
              this.mergeTags(results);
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      handleSelect(item) {
        if (!this.checkedTagIds.includes(item.id)) {
          this.checkedTagIds.push(item.id);
          this.checkedTags.push(item);
        }
        this.searchTag = item.name;
      },
      handleCoverChange () {
        this.$openMaterialLib((list) => {
          if (!list || list.length === 0) {
            return;
          }

          this.coverImage = {
            src: list[0].contentUrl,
            url: list[0].contentUrl,
          }
        }, 1);
      },
      handleImageChange (file, fileList, isCover) {
        if (!file) {
          return;
        }

        var image = { src: util.getObjectURL(file.raw), file: file.raw, id: util.getUUid() }
        this.images.push(image)
      },
      handleRemoveCover () {
        if (this.coverImage.src) {
          window.URL.revokeObjectURL(this.coverImage.src);
          this.coverImage = null;
        }
      },
      handleContentImageChange (file, fileList) {
        // this.handleImageChange (file, fileList, false)
        this.$openMaterialLib((list) => {
          if (!list || list.length === 0) {
            return;
          }
          list.forEach(item => {
            if (this.images.length >= 9) {
              return;
            }

            this.images.push({
              src: item.contentUrl,
              url: item.contentUrl,
            })
          });
        }, 9 - this.images.length);
      },
      handleRemoveContentImage (index) {
        if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
          this.images.splice(index, 1)
        }

        if (this.mediaType === AttachmentMediaTypeEnum.VIDEO.code) {
          const image = this.videoImages[index];
          this.videoImages.splice(index, 1);
          this.coverUrl = ''
          window.URL.revokeObjectURL(image.src);
          window.URL.revokeObjectURL(this.video.src);
          this.video = null;
        }
      },
      async handleVideoChange(elefile, fileList) {
        if (!elefile || !elefile.raw) {
          return;
        }

        const file = elefile.raw;
        let suffix = file.name.substring(file.name.lastIndexOf('.'));
        suffix = suffix.toLowerCase();
        if (!suffix.match(/.mp4|.mov|.avi|.3pg|.rmvb|.flv/i)) {
          this.$message({
            message: '暂不支持此格式',
            type: 'error'
          })
          throw new Error('暂不支持此格式');
        }

        const coverImage = await util.generatorVideoCoverImage(file);
        const videomData = {
          coverImage,
          file,
          id: util.getUUid(),
        };

        const image = { src: coverImage.src, file: coverImage.file, id: util.getUUid() }
        this.videoImages.push(image)

        this.video = videomData;
      },
      async getDomainWhiteList() {
        const { data } = await this.requestWrapper(remote, "domain_white_list");
        if (!!data[0].value) {
          this.domainWhiteList = data[0].value.split(",");
        }
      }, 
      openAddLinkDialog() {
        this.linksForm.links = _.cloneDeep(this.checkedLinks);
        if (this.linksForm.links.length === 0) {
          this.linksForm.links.push({
            id: undefined,
            text: '',
            textEn: '',
            url: '',
          });
        }
        this.addLinkDialogVisible = true;
      },
      addLink() {
        this.linksForm.links.push({
          id: undefined,
          text: '',
          textEn: '',
          url: '',
        });
      },
      removeLink(link, index) {
        this.linksForm.links.splice(index, 1);
      },
      confirmAddLinks(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.checkedLinks = this.linksForm.links;
            this.addLinkDialogVisible = false;
          }
        });
      },
      clickLink(url) {
        window.open(url);
      },
      handleRemoveCheckedLink(link, index) {
        this.checkedLinks.splice(index, 1);
      },
      async savePost (isBanned) {
        try {
          if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
            if (this.images.length === 0) {
              this.$message({
                message: '请选择内容素材',
                type: 'error'
              })
              return;
            }
          } else if (this.mediaType === AttachmentMediaTypeEnum.VIDEO.code) {
            if (this.video === null) {
              this.$message({
                message: '请选择内容素材',
                type: 'error'
              })
              return;
            }
          }

          this.isShowLoading =  true;
          let files = [];
          let coverUrl = '';
          if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
            coverUrl = this.images[0].url;
          } else {
            if (this.coverImage && this.coverImage.url) {
              coverUrl = this.coverImage.url;
            } else {
                const videoImages = this.videoImages.filter(item => !item.url)

              for (let i = 0; i < videoImages.length; i++) {
                const item = videoImages[i];
                const key = await util.getFileKeyAsync(item.file, util.getOSSPostPath());
                files.push({
                  id: item.id,
                  file: item.file,
                  key: key,
                })
              }

              if (files.length > 0) {
                const uploadedUrls = await uploadService.uploadFiles(files);
                uploadedUrls.forEach(item => {
                  const image = this.videoImages.find(image => image.id === item.id);
                  image.url = item.fileUrl;
                });
              }

              coverUrl = this.videoImages[0].url;
            }
          }

          var postData = {
            title: this.title,
            titleEn: this.titleEn,
            contentType: 0,
            content: this.content,
            contentEn: this.contentEn,
            circleId: this.circleId,
            coverImg: coverUrl,
            isBanned: isBanned,
            banComment: "",
            publishStatus: 1,
            postLinks: this.checkedLinks,
            postTags: this.checkedTags.map(item => { return {tagName: item.name, tagNameEn: item.nameEn, tagId: item.id}; }),
            postType: this.mediaType === AttachmentMediaTypeEnum.IMAGE.code ? 0 : 1, // 0 帖子 1 视频
          }

          if (this.mediaType === AttachmentMediaTypeEnum.IMAGE.code) {
            postData.attachments = this.images.map((item) => ({
              thumbnailUrl: item.url,
              attachmentUrl: item.url,
              mediaType: AttachmentMediaTypeEnum.IMAGE.code,
            }));
          } else if(this.mediaType === AttachmentMediaTypeEnum.VIDEO.code) {
            if (!this.video.url) {
              const params = {};
              params.isDefaultVideoCover = !this.coverImage || !this.coverImage.src;
              const vodSignature = await this.requestWrapper(tencentCloud.getVodSign, params);
              if (!vodSignature || vodSignature.ok === false) {
                this.$message({
                  message: '暂不支持此格式',
                  type: 'error'
                })
                throw new Error('获取vod签名失败');
              }

              const uploadVideoResponse = await tencentVodService.uploadVideo(this.video.file, vodSignature);
              this.video.url = uploadVideoResponse.url;
              this.video.fileId =  uploadVideoResponse.fileId;
            }

            postData.attachments = [{
              thumbnailUrl: coverUrl,
              attachmentUrl: this.video.url,
              convertStreamUrl: this.video.convertStreamUrl,
              mediaType: AttachmentMediaTypeEnum.VIDEO.code,
              fileId: this.video.fileId
            }];
          }

          let saveResult = null;
          if (this.isEdit) {
            postData.id = this.id;
            saveResult = await this.requestWrapper(updatePost, postData)
          } else {
            saveResult = await this.requestWrapper(createPost, postData)
          }

          if (!saveResult || saveResult.ok === false || saveResult.code !== 0) {
            this.$message({
              message: saveResult.message || '保存失败',
              type: 'error'
            })
            throw new Error('保存失败');
          }

          this.$message({
            message: isBanned === bannedTypeEnum.BANNED.value ? '保存成功' : '发布成功',
            type: 'success'
          })
          this.$router.back();
        } catch (error) {
          this.isShowLoading =  false;
          console.error(error);
        }
      },
      async init () {
        const postResponse = await this.requestWrapper(getPost, this.$route.query.id);
        if (!postResponse || postResponse.ok === false || postResponse.code !== 0) {
          vm.$message({
            showClose: true,
            message: '未查询到该帖子',
            type: 'error'
          });
        }
        const post = postResponse.data;
        const checkedTagIds = [];
        this.checkedTags = post.postTags.filter((item)=> {
          if (!checkedTagIds.includes(item.tagId)) {
            checkedTagIds.push(item.tagId);
            return true;
          }
          return false;
        }).map((item)=> {return {id: item.tagId, name: item.tagName, nameEn: item.tagNameEn}})
        this.checkedTagIds = checkedTagIds;
        
        this.mergeTags(this.checkedTags);
        // post: '',
        // content: '',
        // title: '',
        // tag: [],
        // id: '',
        // url: '',
        // coverImage: null,
        // images: [],
        // videoImages: [],
        // mediaType: AttachmentMediaTypeEnum.IMAGE.code,
        // video: null,
        // isShowLoading: false,
        // isEdit: false,

        this.title = post.title;
        this.titleEn = post.titleEn;
        this.content = post.content;
        this.contentEn = post.contentEn;
        this.id = post.id;
        this.checkedLinks = post.postLinks;

        if (post.postType === postTypeEnum.IMAGE) {
          this.mediaType = AttachmentMediaTypeEnum.IMAGE.code;
          this.images = post.attachments.map(item => {
            return {
              src: item.attachmentUrl,
              url: item.attachmentUrl
            }
          });
        } else if (post.postType === postTypeEnum.VIDEO) {
          this.mediaType = AttachmentMediaTypeEnum.VIDEO.code;
          this.coverImage = {
            src: post.coverImg,
            url: post.coverImg,
          }
          if (post.attachments.length > 0) {
            this.videoImages = post.attachments.map(item => {
              return {
                src: item.thumbnailUrl,
                url: item.thumbnailUrl
              }
            });

            this.video = {
              url: post.attachments[0].attachmentUrl,
              fileId: post.attachments[0].fileId,
              convertStreamUrl: post.attachments[0].convertStreamUrl,
            }
          }
        }
      },
    },
    mounted() {
      if(!this.$route.query) {
        this.$router.back();
        return;
      }

      if(!this.$route.query.circleId && !isNaN(this.$route.query.circleId)) {
        this.$router.back();
        return;
      }

      if(this.$route.query.id && !isNaN(this.$route.query.id)) {
        this.isEdit = true;
        this.init();
      }

      this.getRelatedTagOptionse();
      this.getDomainWhiteList();
    }
  }
</script>

<style lang="scss" scoped>
.content-background {
  .content-mode {
    .icon {
      margin: 0;
      padding: 0;
      background-color: #5383f3;
      height: 2px;
      width: 32px;
      margin: auto;
      margin-top: 12px;
    }
    .header {
      display: flex;
      align-content: center;
      .label {
        margin: auto;
      }
      .left {
        margin-bottom: 0px;
        text-align: center;
        padding: 0px 40px;

      }
      .right {
        margin-bottom: 0px;
        text-align: center;
        padding: 0px 40px;
      }
    }
    .divider-container {
      padding: 0px 19px;
    }
  }
  .add-content {
    .limit {
      font-size: 14px;
      color: #AFAFAF;
      margin-left: 12px;
    }
    .show-tags {
      margin: 20px 0;
      .el-tag {
        margin: 0 5px;
        border-radius: 15px;
        color: #5383F3;
        font-weight: bold;
        border: none;
      }
    }
    .show-links {
      .el-tag {
        margin: 20px 5px 10px 0;
        border-radius: 15px;
        color: #5383F3;
        font-weight: bold;
        border: none;
      }
      .el-tag:not(:first-child) {
        margin-top: 0;
      }
      .link {
        display: inline-block;
        cursor: pointer;
        span {
          color: #5383F3;
          text-decoration:underline;
          font-weight: bold;
          font-size: 14px;
        }
        .icon-link {
          display: inline-block;
          position: relative;
          top: 4px;
          margin-right: 4px;
          width: 16px;
          height: 16px;
          background-size: 16px 16px;
          background-image: url("../../../static/images/content/icon-link.png");
        }
      }
    }
    .content-area {
      width: 920px;
      position: relative;
      .content-image-input {
        width: 100%;
        position: relative;
      }
      .limit {
        position: absolute;
        bottom: 8px;
        right: 8px;
      }
    }
    .content-footer {
      text-align: right;
    }
  }
  .handle-dialog {
    .search {
      margin: 0 16px 16px;
      width: 35%;
      .search-result {
        position: relative;
        overflow-y: scroll;
      }
    }
    .content {
      height: 377px;
      border-bottom: 1px solid #DDDDDD;
      display: flex;
      justify-content: space-between;
      .left {
        width: 120px;
        height: 377px;
        background-color: white;
        overflow-y: scroll;
      }

      .right {
        width: 826px;
        height: 377px;
        background-color: white;
        overflow-y: scroll;

        .el-checkbox-group {
          margin: 35px 72px;
          .el-checkbox {
            width: 180px;
            margin: 24px 0 0 0;
            line-height: 14px;
            /deep/ .el-checkbox__label {
              width: 140px;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            /deep/ .el-checkbox__inner {
              margin-bottom: 7px;
            }
          }
        }
      }
    }
    .footer {
      // height: 68px;
      background-color: white;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .tags {
        padding: 0 16px 12px 12px;
        .el-tag {
          margin: 12px 12px 0 0;
          border-radius: 15px;
          color: #5383F3;
          font-weight: bold;
          border: none;
        }
      }

      .el-button--primary {
        margin: 16px;
      }
    }
    /deep/ .el-dialog {
      background-color: #F6F8FB;
      display: flex;
      flex-direction: column;
      width: 952px;
      .el-dialog__body {
        padding: 0;
      }
      .el-dialog__title {
        color: #3B3B3B;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .links-content {
    padding: 20px;
    background-color: white;
    .domain-white-list {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .links {
      /deep/ .el-form-item__content {
        margin-left: 0!important;
      }
      .link {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .text,
        .text-en,
        .url {
          display: flex;
          align-items: center;
          label {
            width: 45px;
            text-align: left;
          }
          /deep/ .el-input__inner {
            width: 215px;
          }
        }
        .text-en {
          label {
            width: 100px;
          }
        }
        .text-en,
        .url {
          margin-left: 8px;
        }
        i {
          transform: scale(1.5,1.5);
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
  }
  
}
</style>
